import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import { useTheme } from '@mui/material/styles';
import { Button, Grid2 as Grid, Link, useMediaQuery } from '@mui/material';

const videos = [
  {
    title: "You've decided to run for office. Start here first! (Depository system)",
    link: 'https://www.youtube.com/embed/JV-ApsEQCh4?si=ZCTkDVc4-tg96rH2',
  },
  {
    title: 'Create and e-file a deposit report',
    link: 'https://www.youtube.com/embed/Ce09jG2PDKQ?si=JSVXwWgSCTa6mtWY',
  },
  {
    title: 'How to organize online with OCPF',
    link: 'https://www.youtube.com/embed/Ct6-y4wXVyM?si=mY53aNl_RXsXF7lF',
  },
  {
    title: 'Tutorial for municipal candidates who file locally',
    link: 'https://www.youtube.com/embed/wLxnMQFE4nA?si=x8jI-cWqOf7fRIB9',
  },
];

const FeaturedVideos = (): JSX.Element => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: isMd ? 3 : 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <Box marginTop={5} marginBottom={5}>
      <Box marginTop={3} marginBottom={3}>
        <Typography
          variant="h6"
          sx={{
            textTransform: 'uppercase',
          }}
          fontWeight={700}
          data-aos={'fade-up'}
          gutterBottom
          color={'secondary'}
          align={'center'}
        >
          Featured Videos
        </Typography>
      </Box>
      <Grid container>
        <Box maxWidth={{ xs: 420, sm: 620, md: 1 }} margin={'0 auto'}>
          <Slider  {...sliderSettings}>
            {videos.map((item, index) => (
                <Grid
                 tabIndex={-1}
                  key={index}
                  size={{ xs: 12, md: 4 }}
                  data-aos="fade-up"
                >
                  <Box width={1} height={1} padding={{ xs: 1, md: 2, lg: 3 }}>
                    <Box
                      width={1}
                      height={1}
                      sx={{
                        textDecoration: 'none',
                        transition: 'all .2s ease-in-out',
                        '&:hover': {
                          transform: `translateY(-${theme.spacing(1 / 2)})`,
                        },
                      }}
                    >
                      <Box
                        component={Card}
                        width={1}
                        height={1}
                        sx={{ backgroundImage: 'none' }}
                      >
                        <CardMedia
                          title={item.title}
                          sx={{
                            position: 'relative',
                            height: { xs: 240, sm: 340, md: 280 },
                            overflow: 'hidden',
                          }}
                        >
                          <iframe
                            height={"100%"}
                            width={"100%"}
                            src={item.link}
                            title={item.title}
                            aria-label={item.title + '-video'}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share">
                          </iframe>
                        </CardMedia>
                        <CardContent>
                          <Typography
                            variant={'subtitle1'}
                            gutterBottom
                            align={'left'}
                            color='primary'
                            sx={{ fontWeight: 550 }}
                          >
                            {item.title}
                          </Typography>
                        </CardContent>
                        <Box flexGrow={1} />
                      </Box>
                    </Box>
                  </Box>
                </Grid>
            ))}
          </Slider>
        </Box>
      </Grid>
      <Box marginTop={8} display={'flex'} justifyContent={'center'}>
        <Button
          aria-label='view all help videos'
          title='view all help videos'
          variant="outlined"
          color="primary"
          size="large"
          component={Link}
          data-aos={'fade-up'}
          href='/Publications/Videos'
        >
          View All Help Videos
        </Button>
      </Box>
    </Box>
  );
};

export default FeaturedVideos;
